import DefaultElementNodeType from '../DefaultElementNodeType';
import {BUSINESS_ACTOR} from '../../metamodel/Concept';

export default class BusinessActorNodeType extends DefaultElementNodeType {
	static get typeName() {
		return BUSINESS_ACTOR;
	}
}
